export const financePrepaid = {
  'finance.prepaid.create': 'Создать покупку',
  'finance.prepaid.service': 'Услуга',
  'finance.prepaid.package': 'Опубликованный пакет',
  'finance.prepaid.customServices': 'Индивидуальный набор услуг',
  'finance.prepaid.addService': 'Добавить услугу',
  'finance.prepaid.removeService': 'Убрать услугу',
  'finance.prepaid.previewPurchase': 'Рассчитать покупку',
  'finance.prepaid.purchaseTerms': 'Условия покупки',
  'finance.prepaid.quotedQuantity': 'Количество: {quantity}',
  'finance.prepaid.selectionRequired': 'Выберите получателя, филиал и услуги с положительным количеством. Общее количество не может превышать миллион.',
  'finance.prepaid.purchasePreviewRequired': 'Получите актуальный расчёт покупки перед подтверждением.',
  'finance.prepaid.title': 'Предоплата',
  'finance.prepaid.description': 'Оплата, единицы услуг и неиспользованный остаток',
  'finance.prepaid.purchase': 'Предоплаченная покупка',
  'finance.prepaid.beneficiary': 'Получатель услуг',
  'finance.prepaid.date': 'Дата покупки',
  'finance.prepaid.state': 'Состояние',
  'finance.prepaid.pending': 'Ожидает полной оплаты',
  'finance.prepaid.active': 'Активна',
  'finance.prepaid.canceled': 'Отменена',
  'finance.prepaid.price': 'Стоимость покупки',
  'finance.prepaid.funded': 'Оплачено',
  'finance.prepaid.consumed': 'Использовано',
  'finance.prepaid.released': 'Высвобождено',
  'finance.prepaid.remaining': 'Удерживаемый остаток',
  'finance.prepaid.lines': 'Услуги',
  'finance.prepaid.quantities': 'Куплено: {purchased}; использовано: {used}; возвращено: {returned}; доступно: {available}',
  'finance.prepaid.fund': 'Внести оплату',
  'finance.prepaid.cancel': 'Отменить покупку',
  'finance.prepaid.return': 'Вернуть неиспользованные единицы',
  'finance.prepaid.loading': 'Загрузка предоплаты',
  'finance.prepaid.empty': 'Предоплаченных покупок нет',
  'finance.prepaid.emptyDetail': 'Покупки ещё не зарегистрированы.',
  'finance.prepaid.noMatches': 'Покупки не найдены',
  'finance.prepaid.noMatchesDetail': 'Покупок с выбранным состоянием нет.',
  'finance.prepaid.failed': 'Не удалось выполнить операцию с предоплатой.',
  'finance.prepaid.changed': 'Покупка или счёт изменились. Загрузите сохранённые данные заново.',
  'finance.prepaid.stateChanged': 'Состояние покупки не допускает эту операцию.',
  'finance.prepaid.unitsUnavailable': 'Некоторые выбранные единицы больше недоступны.',
  'finance.prepaid.fundingExceeded': 'Сумма превышает неоплаченный остаток покупки.',
  'finance.prepaid.unsaved': 'несохранённые данные предоплаты',
  'finance.prepaid.reasonRequired': 'Укажите причину длиной не менее трёх символов.',
  'finance.prepaid.previewRequired': 'Выберите доступные единицы и получите актуальный расчёт возврата.',
  'finance.prepaid.confirm': 'Подтвердить',
  'finance.prepaid.saving': 'Сохранение',
  'finance.prepaid.unitRange': 'Единицы с {first} по {last}',
  'finance.prepaid.firstUnit': 'Первая единица',
  'finance.prepaid.quantity': 'Количество',
  'finance.prepaid.more': 'Загрузить ещё',
  'finance.prepaid.preview': 'Рассчитать возврат',
  'finance.prepaid.releaseAmount': 'Возврат в исходные средства',
  'finance.prepaid.net': 'Без налога',
  'finance.prepaid.tax': 'Включённый налог',
  'finance.prepaid.noPayout': 'Стоимость возвращается на исходные счета. Выплата денег не регистрируется.',
  'finance.prepaid.reason': 'Причина',
  'finance.prepaid.unfunded': 'Осталось оплатить',
  'finance.prepaid.fundsOwner': 'Владелец исходного счёта',
  'finance.prepaid.account': 'Исходный счёт',
  'finance.prepaid.noAccounts': 'У владельца нет активных счетов.',
  'finance.prepaid.receipt': 'Исходное поступление',
  'finance.prepaid.receiptOption': '{date}: доступно {amount}',
  'finance.prepaid.noReceipts': 'На счёте нет поступлений.',
  'finance.prepaid.receiptRequired': 'Выберите исходный счёт и поступление.',
  'finance.prepaid.maximum': 'Доступно для этой покупки',
  'finance.prepaid.amount': 'Сумма оплаты',
  'finance.prepaid.amountRequired': 'Укажите положительную сумму в пределах доступного остатка.',
  'finance.prepaid.ownerInstruction': 'Владелец счёта разрешил оплату для этого получателя услуг.',
  'finance.prepaid.instructionRequired': 'Подтвердите распоряжение владельца счёта.',
  'finance.prepaid.reference': 'Основание оплаты',
  'finance.prepaid.referenceRequired': 'Укажите основание длиной не менее трёх символов.',
} as const
